export const ADMIN_LOGIN_STORAGE_KEY = '@paytop/adminLogin';
